




































import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
    name: 'WokChartBulletMini',

    props: {
        width: {
            type: [String, Number],
            default: 100
        },
        height: {
            type: [String, Number],
            default: 18
        },
        bgColor: {
            type: String,
            default: ''
        },
        barColor: {
            type: String,
            default: ''
        },
        strokeColor: {
            type: String,
            default: ''
        },
        values: {
            type: Array,
            default: () => []
        }
    },

    setup(props, context) {
        const viewBox = computed(() => {
            return `0 0 ${props.width} ${props.height}`;
        });

        return {
            viewBox
        }
    }
})
